// import React, { useState } from 'react';
// import { Link, useNavigate } from 'react-router-dom';
// import { authAPI, employeesAPI } from '../../services/api';
// import { toast } from 'react-toastify';
// import 'react-toastify/dist/ReactToastify.css';
// import '../../styles/Login.css';

// const Login = ({ setIsAuthenticated }) => {
//   const navigate = useNavigate();
//   const [loginType, setLoginType] = useState('user'); // 'user' | 'employee'
//   const [formData, setFormData] = useState({ email: '', password: '' });
//   const [errors, setErrors] = useState({});
//   const [showPassword, setShowPassword] = useState(false);
//   const [loading, setLoading] = useState(false);

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setFormData(prev => ({ ...prev, [name]: value }));
//   };

//   const validateForm = () => {
//     const newErrors = {};
//     if (!formData.email.trim()) {
//       newErrors.email = 'Email is required';
//     } else if (!/^\S+@\S+\.\S+$/.test(formData.email)) {
//       newErrors.email = 'Please enter a valid email address';
//     }
//     if (!formData.password) {
//       newErrors.password = 'Password is required';
//     } else if (formData.password.length < 3) {
//       newErrors.password = 'Password must be at least 3 characters';
//     }
//     setErrors(newErrors);
//     return Object.keys(newErrors).length === 0;
//   };

//   // ── Decode JWT payload ────────────────────────────────────────────────────
//   const decodeToken = (token) => {
//     try {
//       const parts = token.split('.');
//       if (parts.length !== 3) return null;
//       const base64 = parts[1].replace(/-/g, '+').replace(/_/g, '/');
//       const decoded = atob(base64);
//       try {
//         return JSON.parse(decoded);
//       } catch {
//         const jsonPayload = decodeURIComponent(
//           decoded.split('').map(c => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)).join('')
//         );
//         return JSON.parse(jsonPayload);
//       }
//     } catch {
//       return null;
//     }
//   };

//   // ── Normalize role — strip ROLE_ prefix, uppercase ───────────────────────
//   const normalizeRole = (raw) => {
//     if (!raw) return '';
//     const val = Array.isArray(raw) ? raw[0] : raw;
//     return String(val).toUpperCase().trim().replace(/^ROLE_/, '');
//   };

//   // ── Store common auth data ────────────────────────────────────────────────
//   const storeAuthData = (data, token) => {
//     localStorage.setItem('token', token);
//     if (data.email) localStorage.setItem('email', data.email);

//     const userId = data.id || data.userId || data.user?.id;
//     if (userId) localStorage.setItem('userId', String(userId));

//     const role = normalizeRole(data.role || data.roles);
//     if (role) localStorage.setItem('userRole', role);

//     if (data.organizationId)  localStorage.setItem('organizationId', data.organizationId);
//     if (data.organizationName) localStorage.setItem('organizationName', data.organizationName);
//     if (typeof data.noOfUsers !== 'undefined') localStorage.setItem('noOfUsers', String(data.noOfUsers));

//     // Fallback: extract from JWT
//     if (!localStorage.getItem('userId')) {
//       const payload = decodeToken(token);
//       if (payload) {
//         const extractedId = payload.userId || payload.id || payload._id || payload.user_id;
//         if (extractedId) localStorage.setItem('userId', String(extractedId));
//         if (payload.organizationId && !localStorage.getItem('organizationId'))
//           localStorage.setItem('organizationId', payload.organizationId);
//         if (!localStorage.getItem('userRole')) {
//           const tokenRole = normalizeRole(payload.roles || payload.role);
//           if (tokenRole) localStorage.setItem('userRole', tokenRole);
//         }
//       }
//     }

//     try {
//       localStorage.setItem('userProfile', JSON.stringify(data.user || data.profile || data));
//     } catch { /* ignore */ }
//   };

//   // ── Redirect path by role ─────────────────────────────────────────────────
//   // SUPERADMIN always lands on /superadmin/dashboard
//   const getRedirectPath = (role) => {
//     if (role === 'SUPERADMIN') return '/superadmin/dashboard';
//     return '/';
//   };

//   // ── User Login ────────────────────────────────────────────────────────────
//   const handleUserLogin = async () => {
//     const res = await authAPI.login({ email: formData.email, password: formData.password });
//     if (res.status === 200 && res.data.token) {
//       storeAuthData(res.data, res.data.token);

//       // Fetch profile if role still missing
//       if (!localStorage.getItem('userRole')) {
//         try {
//           const profileRes = await authAPI.getProfile(res.data.email || formData.email);
//           const profile = profileRes.data;
//           const roleVal = normalizeRole(profile.role || profile.roles);
//           if (roleVal) localStorage.setItem('userRole', roleVal);
//           if (profile.organizationId) localStorage.setItem('organizationId', profile.organizationId);
//           if (profile.organizationName) localStorage.setItem('organizationName', profile.organizationName);
//           if (!localStorage.getItem('userId') && profile.id) localStorage.setItem('userId', profile.id);
//           // Also update userProfile blob with fresh data
//           try { localStorage.setItem('userProfile', JSON.stringify(profile)); } catch { /* ignore */ }
//         } catch { /* ignore */ }
//       }

//       localStorage.setItem('loginType', 'user');

//       const role = localStorage.getItem('userRole') || '';
//       const isSuperAdmin = role === 'SUPERADMIN';

//       toast.success(
//         isSuperAdmin ? '🛡️ Super Admin login successful!' : 'Login successful!',
//         { position: 'top-center' }
//       );

//       if (setIsAuthenticated) setIsAuthenticated(true);
//       navigate(getRedirectPath(role));
//     } else {
//       toast.error('Invalid response from server', { position: 'top-center' });
//     }
//   };

//   // ── Employee Login ────────────────────────────────────────────────────────
//   const handleEmployeeLogin = async () => {
//     const res = await employeesAPI.employeeLogin({ email: formData.email, password: formData.password });
//     if (res.status === 200 && res.data.token) {
//       storeAuthData(res.data, res.data.token);
//       localStorage.setItem('loginType', 'employee');
//       // Employees are never SUPERADMIN — ensure a safe default role
//       if (!localStorage.getItem('userRole')) {
//         localStorage.setItem('userRole', 'EMPLOYEE');
//       }
//       toast.success('Employee login successful!', { position: 'top-center' });
//       if (setIsAuthenticated) setIsAuthenticated(true);
//       navigate('/');
//     } else {
//       toast.error('Invalid response from server', { position: 'top-center' });
//     }
//   };

//   // ── Submit ────────────────────────────────────────────────────────────────
//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     if (!validateForm()) return;
//     setLoading(true);
//     try {
//       if (loginType === 'employee') {
//         await handleEmployeeLogin();
//       } else {
//         await handleUserLogin();
//       }
//     } catch (error) {
//       console.error('Login error:', error);
//       const errMsg = error.response?.data || 'Internal server error. Please try again.';
//       toast.error(typeof errMsg === 'string' ? errMsg : JSON.stringify(errMsg), { position: 'top-center' });
//     } finally {
//       setLoading(false);
//     }
//   };

//   const togglePasswordVisibility = () => setShowPassword(prev => !prev);

//   return (
//     <div className="login-container">
//       <div className="login-left-section">
//         <div className="login-logo-container">
//           <div className="login-circle-logo">
//             <span className="login-ats-logo">ATS</span>
//           </div>
//           <span className="login-circle-text">CIRCLE</span>
//         </div>

//         <h1>Welcome Back!</h1>
//         <p>
//           Log in to continue managing your recruitment process efficiently with ATS Circle.
//         </p>

//         <ul className="login-features-list">
//           <li><span className="login-checkmark">✓</span> Track candidates efficiently</li>
//           <li><span className="login-checkmark">✓</span> Manage leads and clients</li>
//           <li><span className="login-checkmark">✓</span> Create and send invoices</li>
//           <li><span className="login-checkmark">✓</span> Access everything in one dashboard</li>
//           <li><span className="login-checkmark">✓</span> All in one integrated solution</li>
//           <li><span className="login-checkmark">✓</span> User friendly interface</li>
//           <li><span className="login-checkmark">✓</span> Affordable pricing plans</li>
//         </ul>
//       </div>

//       <div className="login-right-section">
//         <div className="login-form-container">
//           <div className="login-welcome-section">
//             <h3>Log In to Your Account</h3>
//             <p className="login-welcome-text">Welcome back! Please enter your details</p>
//           </div>

//           {/* Login Type Toggle */}
//           <div style={{
//             display: 'flex', background: '#f3f4f6', borderRadius: '10px',
//             padding: '4px', marginBottom: '24px', gap: '4px'
//           }}>
//             {['user', 'employee'].map(type => (
//               <button
//                 key={type}
//                 type="button"
//                 onClick={() => { setLoginType(type); setErrors({}); }}
//                 style={{
//                   flex: 1, padding: '8px 0', borderRadius: '8px', border: 'none',
//                   cursor: 'pointer', fontSize: '14px', fontWeight: '600', transition: 'all 0.2s',
//                   background: loginType === type ? '#ffffff' : 'transparent',
//                   color: loginType === type ? '#1d4ed8' : '#6b7280',
//                   boxShadow: loginType === type ? '0 1px 4px rgba(0,0,0,0.12)' : 'none',
//                 }}
//               >
//                 {type === 'user' ? 'User Login' : 'Employee Login'}
//               </button>
//             ))}
//           </div>

//           {/* Info banner */}
//           <div style={{
//             marginBottom: '16px', padding: '8px 12px', borderRadius: '8px',
//             background: loginType === 'employee' ? '#eff6ff' : '#f0fdf4',
//             border: `1px solid ${loginType === 'employee' ? '#bfdbfe' : '#bbf7d0'}`,
//             fontSize: '13px', color: loginType === 'employee' ? '#1d4ed8' : '#15803d',
//             display: 'flex', alignItems: 'center', gap: '6px'
//           }}>
//             <span>{loginType === 'employee' ? '👤' : '🏢'}</span>
//             <span>
//               {loginType === 'employee'
//                 ? 'Logging in as Employee — use your employee credentials'
//                 : 'Logging in as User / Admin — use your organization credentials'}
//             </span>
//           </div>

//           {/* Form */}
//           <form className="login-form" onSubmit={handleSubmit}>
//             <div className="login-form-group">
//               <label>Email *</label>
//               <input
//                 type="email" name="email" placeholder="Enter your email"
//                 value={formData.email} onChange={handleChange}
//                 className={errors.email ? 'login-error' : ''}
//               />
//               {errors.email && <span className="login-error-text">{errors.email}</span>}
//             </div>

//             <div className="login-form-group">
//               <label>Password *</label>
//               <div className="login-password-container">
//                 <input
//                   type={showPassword ? 'text' : 'password'} name="password"
//                   placeholder="Enter your password" value={formData.password}
//                   onChange={handleChange} className={errors.password ? 'login-error' : ''}
//                 />
//                 <span className="login-password-toggle" onClick={togglePasswordVisibility}>
//                   {showPassword ? (
//                     <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" width="20" height="20">
//                       <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M2.458 12C3.732 7.943 7.523 5 12 5c4.477 0 8.268 2.943 9.542 7-1.274 4.057-5.065 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
//                       <circle cx="12" cy="12" r="3" stroke="currentColor" strokeWidth={2} fill="none" />
//                       <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 3l18 18" />
//                     </svg>
//                   ) : (
//                     <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" width="20" height="20">
//                       <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M2.458 12C3.732 7.943 7.523 5 12 5c4.477 0 8.268 2.943 9.542 7-1.274 4.057-5.065 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
//                       <circle cx="12" cy="12" r="3" stroke="currentColor" strokeWidth={2} fill="none" />
//                     </svg>
//                   )}
//                 </span>
//               </div>
//               {errors.password && <span className="login-error-text">{errors.password}</span>}
//             </div>

//             <div className="login-remember-forgot">
//               <div className="login-remember-me">
//                 <input type="checkbox" id="remember" />
//                 <label htmlFor="remember">Remember me</label>
//               </div>
//               <Link to="/forgot-password" className="login-forgot-link">Forgot password?</Link>
//             </div>

//             <button
//               type="submit" className="login-btn" disabled={loading}
//               style={{ opacity: loading ? 0.7 : 1, cursor: loading ? 'not-allowed' : 'pointer' }}
//             >
//               <strong>
//                 {loading ? 'Logging in...' : loginType === 'employee' ? 'Employee Log In' : 'Log In'}
//               </strong>
//             </button>

//             {loginType === 'user' && (
//               <p className="login-signup-link">
//                 Don't have an account? <Link to="/register">Sign up</Link>
//               </p>
//             )}
//           </form>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default Login;

import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { authAPI, employeesAPI } from '../../services/api';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import '../../styles/Login.css';

const Login = ({ setIsAuthenticated, setMustChangePassword }) => {
  const navigate = useNavigate();
  const [loginType, setLoginType] = useState('user'); // 'user' | 'employee'
  const [formData, setFormData] = useState({ email: '', password: '' });
  const [errors, setErrors] = useState({});
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const [loginError, setLoginError] = useState('');

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
    if (loginError) setLoginError('');
  };

  const validateForm = () => {
    const newErrors = {};
    if (!formData.email.trim()) {
      newErrors.email = 'Email is required';
    } else if (!/^\S+@\S+\.\S+$/.test(formData.email)) {
      newErrors.email = 'Please enter a valid email address';
    }
    if (!formData.password) {
      newErrors.password = 'Password is required';
    } else if (formData.password.length < 3) {
      newErrors.password = 'Password must be at least 3 characters';
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  // ── Decode JWT payload ────────────────────────────────────────────────────
  const decodeToken = (token) => {
    try {
      const parts = token.split('.');
      if (parts.length !== 3) return null;
      const base64 = parts[1].replace(/-/g, '+').replace(/_/g, '/');
      const decoded = atob(base64);
      try {
        return JSON.parse(decoded);
      } catch {
        const jsonPayload = decodeURIComponent(
          decoded.split('').map(c => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)).join('')
        );
        return JSON.parse(jsonPayload);
      }
    } catch {
      return null;
    }
  };

  // ── Normalize role — strip ROLE_ prefix, uppercase ───────────────────────
  const normalizeRole = (raw) => {
    if (!raw) return '';
    const val = Array.isArray(raw) ? raw[0] : raw;
    return String(val).toUpperCase().trim().replace(/^ROLE_/, '');
  };

  const normalizeRoles = (raw) => {
    if (!raw) return [];
    const arr = Array.isArray(raw) ? raw : [raw];
    return arr.map(r => String(r).toUpperCase().trim().replace(/^ROLE_/, '')).filter(Boolean);
  };

  // ── Store common auth data ────────────────────────────────────────────────
  const storeAuthData = (data, token) => {
    localStorage.setItem('token', token);
    if (data.email) localStorage.setItem('email', data.email);

    const userId = data.id || data.userId || data.user?.id;
    if (userId) localStorage.setItem('userId', String(userId));

    const roles = normalizeRoles(data.roles || data.role);
    if (roles.length) localStorage.setItem('userRole', JSON.stringify(roles));

    if (data.organizationId) localStorage.setItem('organizationId', data.organizationId);
    if (data.organizationName) localStorage.setItem('organizationName', data.organizationName);
    if (typeof data.noOfUsers !== 'undefined') localStorage.setItem('noOfUsers', String(data.noOfUsers));

    // Fallback: extract from JWT
    if (!localStorage.getItem('userId')) {
      const payload = decodeToken(token);
      if (payload) {
        const extractedId = payload.userId || payload.id || payload._id || payload.user_id;
        if (extractedId) localStorage.setItem('userId', String(extractedId));
        if (payload.organizationId && !localStorage.getItem('organizationId'))
          localStorage.setItem('organizationId', payload.organizationId);
        if (!localStorage.getItem('userRole')) {
          const tokenRoles = normalizeRoles(payload.roles || payload.role);
          if (tokenRoles.length) localStorage.setItem('userRole', JSON.stringify(tokenRoles));
        }
      }
    }

    try {
      localStorage.setItem('userProfile', JSON.stringify(data.user || data.profile || data));
    } catch { /* ignore */ }
  };

  // ── Redirect path by role ─────────────────────────────────────────────────
  const getRedirectPath = (role) => {
    if (role === 'SUPERADMIN') return '/superadmin/dashboard';
    return '/dashboard';
  };

  // ── User Login ────────────────────────────────────────────────────────────
  const handleUserLogin = async () => {
    const res = await authAPI.login({ email: formData.email, password: formData.password });
    if (res.status === 200 && res.data.token) {
      storeAuthData(res.data, res.data.token);

      if (!localStorage.getItem('userRole')) {
        try {
          const profileRes = await authAPI.getProfile(res.data.email || formData.email);
          const profile = profileRes.data;
          const roleVals = normalizeRoles(profile.roles || profile.role);
          if (roleVals.length) localStorage.setItem('userRole', JSON.stringify(roleVals));
          if (profile.organizationId) localStorage.setItem('organizationId', profile.organizationId);
          if (profile.organizationName) localStorage.setItem('organizationName', profile.organizationName);
          if (!localStorage.getItem('userId') && profile.id) localStorage.setItem('userId', profile.id);
          try { localStorage.setItem('userProfile', JSON.stringify(profile)); } catch { /* ignore */ }
        } catch { /* ignore */ }
      }

      localStorage.setItem('loginType', 'user');
      let _parsedRoles;
      try { _parsedRoles = JSON.parse(localStorage.getItem('userRole') || '[]'); } catch { _parsedRoles = []; }
      if (!Array.isArray(_parsedRoles)) _parsedRoles = [_parsedRoles];
      const isSuperAdmin = _parsedRoles.includes('SUPERADMIN');

      toast.success(
        isSuperAdmin ? '🛡️ Super Admin login successful!' : 'Login successful!',
        { position: 'top-center' }
      );

      if (setIsAuthenticated) setIsAuthenticated(true);
      try {
        const profileRes = await authAPI.getProfile(res.data.email || localStorage.getItem('email'));
        if (profileRes.data) {
          localStorage.setItem('userProfile', JSON.stringify(profileRes.data));
        }
      } catch (e) {
        console.error('Could not refresh profile after login', e);
      }
      navigate(getRedirectPath(_parsedRoles[0] || ''));
    }
  };

  // ── Employee Login ────────────────────────────────────────────────────────
  const handleEmployeeLogin = async () => {
    const res = await employeesAPI.employeeLogin({ email: formData.email, password: formData.password });
    if (res.status === 200 && res.data.token) {
      storeAuthData(res.data, res.data.token);
      localStorage.setItem('loginType', 'employee');
      if (!localStorage.getItem('userRole')) {
        localStorage.setItem('userRole', 'EMPLOYEE');
      }
      const mustChange = res.data.mustChangePassword === true;
      localStorage.setItem('mustChangePassword', mustChange ? 'true' : 'false');
      toast.success('Employee login successful!', { position: 'top-center' });
      if (setMustChangePassword) setMustChangePassword(mustChange);
      if (setIsAuthenticated) setIsAuthenticated(true);
      navigate('/dashboard');
    }
  };

  // ── Submit ────────────────────────────────────────────────────────────────
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoginError('');
    if (!validateForm()) return;
    setLoading(true);
    try {
      if (loginType === 'employee') {
        await handleEmployeeLogin();
      } else {
        await handleUserLogin();
      }
    } catch (error) {
      console.error('Login error:', error);
      const errMsg = error.response?.data || 'Internal server error. Please try again.';
      const toastMsg = typeof errMsg === 'string' ? errMsg : JSON.stringify(errMsg);
      setLoginError(typeof errMsg === 'string' ? errMsg : 'Login failed. Please check your credentials and try again.');
      toast.error(toastMsg, { position: 'top-center' });
    } finally {
      setLoading(false);
    }
  };

  const togglePasswordVisibility = () => setShowPassword(prev => !prev);

  return (
    <>
      <div className="login-container">
        <div className="left-section">
          <div className="branding-header">
            <p className="branding-text">THE ONLY TOOL YOUR RECRUITMENT BUSINESS NEEDS</p>
          </div>

          <h1 className="hero-title">
            Your next placement<br />starts here.
          </h1>

          <p className="hero-subtitle">
            Most tools make you pay more as you grow. ClustrOps gives you CRM, ATS, and invoicing — all in one place, at one flat price.
          </p>

          <div className="features-container">
            <div className="feature-item">
              <div className="feature-icon">
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" /><circle cx="9" cy="7" r="4" /><path d="M22 21v-2a4 4 0 0 0-3-3.87" /><path d="M16 3.13a4 4 0 0 1 0 7.75" /></svg>
              </div>
              <div className="feature-text">
                <strong>Client called. Log it, task it, close it.</strong>
                <p>CRM keeps every relationship moving forward.</p>
              </div>
            </div>

            <div className="feature-item">
              <div className="feature-icon">
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="2" y="7" width="20" height="14" rx="2" ry="2" /><path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16" /></svg>
              </div>
              <div className="feature-text">
                <strong>Candidate placed. Invoice drafted. You send it.</strong>
                <p>Mark as hired. Invoice drafts itself. You review and send.</p>
              </div>
            </div>

            <div className="feature-item">
              <div className="feature-icon">
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71" /><path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71" /></svg>
              </div>
              <div className="feature-text">
                <strong>Profile shared. Client responded. No login required.</strong>
                <p>Expiry link. One click. Feedback syncs instantly.</p>
              </div>
            </div>

            <div className="feature-item">
              <div className="feature-icon">
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="3" width="18" height="18" rx="2" ry="2" /><line x1="3" y1="9" x2="21" y2="9" /><line x1="9" y1="21" x2="9" y2="9" /></svg>
              </div>
              <div className="feature-text">
                <strong>Dashboard open. You know exactly what to do.</strong>
                <p>Smart action cards. No guesswork. Just work.</p>
              </div>
            </div>
          </div>

          <div className="badges-container">
            <span className="badge"><span className="badge-dot"></span>Built for India. GST-native.</span>
            <span className="badge"><span className="badge-dot"></span>Flat pricing. No upgrade walls.</span>
            <span className="badge">14-day free trial. No card.</span>
          </div>
        </div>

        <div className="login-right-section">
          <div className="right-section-content">
            <div className="logo-section">
              <img
                src="/clustrops-logo.png"
                alt="ClustrOps"
                style={{ height: 54, objectFit: 'contain' }}
              />

            </div>

            <div className="auth-top-bar">
              <Link to="/register" className="toggle-btn inactive">Start Free Trial</Link>
              <button type="button" className="toggle-btn active">Log In</button>
            </div>

            <div className="form-header">
              <h2 className="form-title">Log In to Your Account</h2>
              <p className="form-subtitle">Welcome back! Please enter your details to continue.</p>
            </div>

            {/* Login Type Toggle */}
            <div className="login-type-toggle">
              {['user', 'employee'].map(type => (
                <button
                  key={type}
                  type="button"
                  className={`type-btn ${loginType === type ? 'active' : ''}`}
                  onClick={() => { setLoginType(type); setErrors({}); setLoginError(''); }}
                >
                  {type === 'user' ? 'User Login' : 'Employee Login'}
                </button>
              ))}
            </div>

            {/* Info banner */}
            <div className={`info-banner ${loginType}`}>
              <span>{loginType === 'employee' ? '👤' : '🏢'}</span>
              <span>
                {loginType === 'employee'
                  ? 'Logging in as Employee — use your employee credentials'
                  : 'Logging in as User / Admin — use your organization credentials'}
              </span>
            </div>

            {/* Form */}
            <form className="signup-form" onSubmit={handleSubmit}>
              <div className="form-group">
                <label>Business Email</label>
                <input
                  type="email" name="email" placeholder="you@company.com"
                  value={formData.email} onChange={handleChange}
                  className={errors.email ? 'error' : ''}
                />
                {errors.email && <span className="error-text">{errors.email}</span>}
              </div>

              <div className="form-group">
                <label>Password</label>
                <div className="password-input-wrapper">
                  <input
                    type={showPassword ? 'text' : 'password'} name="password"
                    placeholder="Your password" value={formData.password}
                    onChange={handleChange} className={errors.password ? 'error' : ''}
                  />
                  <span className="password-toggle-icon" onClick={togglePasswordVisibility}>
                    {showPassword ? (
                      <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"></path><line x1="1" y1="1" x2="23" y2="23"></line></svg>
                    ) : (
                      <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" /><circle cx="12" cy="12" r="3" /></svg>
                    )}
                  </span>
                </div>
                <div style={{ textAlign: 'right', marginTop: '8px' }}>
                  <Link to="/forgot-password" style={{ fontSize: '0.85rem', color: '#1e3a8a', textDecoration: 'none', fontWeight: '600' }}>Forgot password?</Link>
                </div>
                {errors.password && <span className="error-text">{errors.password}</span>}
              </div>

              {loginError && (
                <div
                  className="info-banner"
                  style={{ background: '#fef2f2', border: '1px solid #fecaca', color: '#b91c1c' }}
                  role="alert"
                >
                  <span>⚠️</span>
                  <span>{loginError}</span>
                </div>
              )}

              <button
                type="submit" className="create-account-btn" disabled={loading}
              >
                {loading ? 'Logging in...' : 'Log In to ClustrOps'}
              </button>

              <div className="already-have-account" style={{ marginTop: '24px' }}>
                Don't have an account? <Link to="/register">Start free trial</Link>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

export default Login;